var React = require('react');

function Ribbon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M100.1 101L.1 1H50l50 50.2z","opacity":".3","key":0}),React.createElement("path",{"d":"M100.1 100L.1 0H50l50 50.2z","key":1})]);
}

Ribbon.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Ribbon;

Ribbon.default = Ribbon;
